import { Spinner } from '@platform/components';
import { Control } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from './types';
import { OptionalNote } from './OptionalNote';

/** Org rep confirmation screen for the "It's a match" path (reps don't name/date the project). */
export const OrgRepConfirmMatchContent = (props: {
  control: Control<UpdateDiscoveryCallFormData>;
  isSaving: boolean;
}) => {
  return (
    <div className='flex flex-col gap-4 items-center md:mt-8 md:w-[500px]'>
      {props.isSaving ?
        <Spinner />
      : <>
          <div className='text-center font-semibold text-lg'>Ready to confirm your match?</div>
          <div className='text-center text-lg'>
            By confirming, you're agreeing to work with this professional and committing to being
            responsive and collaborative throughout the project.
          </div>
          <OptionalNote control={props.control} placeholder='Enter details' />
        </>
      }
    </div>
  );
};
